"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var rich_text_types_1 = require("@contentful/rich-text-types");

var rich_text_react_renderer_1 = require("@contentful/rich-text-react-renderer");

var components_1 = require("@lsg/components");

var defaultOptions = {
  renderNode: (_a = {}, _a[rich_text_types_1.BLOCKS.HEADING_1] = function (node, children) {
    return React.createElement(components_1.H1, null, children);
  }, _a[rich_text_types_1.BLOCKS.HEADING_2] = function (node, children) {
    return React.createElement(components_1.H2, null, children);
  }, _a[rich_text_types_1.BLOCKS.HEADING_3] = function (node, children) {
    return React.createElement(components_1.H3, null, children);
  }, _a[rich_text_types_1.BLOCKS.HEADING_4] = function (node, children) {
    return React.createElement(components_1.H4, null, children);
  }, _a[rich_text_types_1.BLOCKS.HEADING_5] = function (node, children) {
    return React.createElement(components_1.H5, null, children);
  }, _a[rich_text_types_1.BLOCKS.PARAGRAPH] = function (node, children) {
    return React.createElement(components_1.Paragraph, null, children);
  }, _a)
};

function createOptions(options) {
  return {
    renderNode: __assign(__assign({}, defaultOptions.renderNode), options)
  };
}

exports.createOptions = createOptions;

exports.ContentfulRichTextRenderer = function (_a) {
  var content = _a.content,
      options = _a.options;
  var realOptions = createOptions(options);
  return React.createElement(React.Fragment, null, rich_text_react_renderer_1.documentToReactComponents(content, realOptions));
};